import { AxiosRequestConfig } from 'axios'
import { apiInstance } from '@shared/api'
import { EmergencyNoticeActiveResponse } from '../model/types'

type SilentRequestConfig = AxiosRequestConfig & {
  suppressGlobalErrorHandler: boolean
}

const silentRequestConfig: SilentRequestConfig = {
  suppressGlobalErrorHandler: true,
}

export const getActiveEmergencyNotices = async () => {
  const res = await apiInstance.get<EmergencyNoticeActiveResponse>(
    '/api/v1/notice/active',
    silentRequestConfig
  )
  return res.data
}
